import React, { PureComponent } from 'react';
import Radium from 'radium';
import { Link } from 'react-router-dom';
import { UTLabel, UTTouchableWithoutFeedback } from '@widergy/energy-ui';

import UTExternalLink from 'app/components/UTExternalLink';
import { buttonTypes } from 'types/sidebarTypes';

import sidebarButtonStyles from '../../styles';
import sidebarButtonStylesCSS from '../../styles.module.scss';

import styles from './styles';

class SidebarDefaultButton extends PureComponent {
  state = {
    hovered: false
  };

  onMouseEnter = () => this.setState({ hovered: true });

  onMouseLeave = () => this.setState({ hovered: false });

  handleContent = () => (
    <div
      onMouseEnter={this.onMouseEnter}
      onMouseLeave={this.onMouseLeave}
      style={this.props.isActive || this.state.hovered ? styles.activeContent : styles.content}
    >
      <img src={this.props.optionImage} alt="" style={styles.sidebarItem} />
      <div style={styles.sidebarText}>
        <UTLabel primary style={sidebarButtonStyles.activeText}>
          {this.props.children}
        </UTLabel>
        {this.props.detail && (
          <UTLabel bold small style={sidebarButtonStyles.activeText}>
            {this.props.detail}
          </UTLabel>
        )}
      </div>
    </div>
  );

  render() {
    return (
      <UTTouchableWithoutFeedback
        onClick={this.props.onClick}
        className={`${sidebarButtonStylesCSS.container} ${
          this.props.isActive ? sidebarButtonStylesCSS.active : sidebarButtonStylesCSS.inactive
        }`}
      >
        {this.props.linkTo && (
          <Link to={this.props.linkTo} style={sidebarButtonStyles.link}>
            {this.handleContent()}
          </Link>
        )}
        {this.props.externalLink && (
          <UTExternalLink url={this.props.externalLink} style={sidebarButtonStyles.link}>
            {this.handleContent()}
          </UTExternalLink>
        )}
      </UTTouchableWithoutFeedback>
    );
  }
}

SidebarDefaultButton.propTypes = buttonTypes;

export default Radium(SidebarDefaultButton);
